// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GeneratePdfFromTemplateRequestContentPoint } from './generatePdfFromTemplateRequestContentPoint.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GeneratePdfFromTemplateRequestContent {
    'page': number;
    'content': string;
    'font': string;
    'size': number;
    'style': number;
    'color': string;
    'point': GeneratePdfFromTemplateRequestContentPoint | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GeneratePdfFromTemplateRequestContent>> = [
        {
            "name":     "page",
            "baseName": "page",
            "type":     "number"
        },
        {
            "name":     "content",
            "baseName": "content",
            "type":     "string"
        },
        {
            "name":     "font",
            "baseName": "font",
            "type":     "string"
        },
        {
            "name":     "size",
            "baseName": "size",
            "type":     "number"
        },
        {
            "name":     "style",
            "baseName": "style",
            "type":     "number"
        },
        {
            "name":     "color",
            "baseName": "color",
            "type":     "string"
        },
        {
            "name":     "point",
            "baseName": "point",
            "type":     "GeneratePdfFromTemplateRequestContentPoint"
        },
    ];

    static getAttributeTypeMap() {
        return GeneratePdfFromTemplateRequestContent.attributeTypeMap;
    }
}
